import React from 'react';

/* eslint-disable max-len,no-tabs,camelcase */
const Eyes_14 = ({ eyeColours, skinColours }) => {
  const colour0 = '#573D39';
  const colour1 = '#F15743';
  const colour2 = '#FFFEF0';
  const colour3 = '#F6E7D0';
  const colour4 = eyeColours.shadow;
  const colour5 = '#DF5656';
  const colour6 = skinColours.shadow;

  return (
    <>
      <g>
        <path
          fill={colour0}
          d="M492.5,369.2c0,0,2.3,27,11.6,31.6c0,0-18.1-2.4-18.8-25.7L492.5,369.2z"
        />
        <g>
          <path
            fill={colour0}
            d="M487.8,377.2c2.3-2,5-6.8,4.7-7.8c-0.3-1.1-12.7-5.3-12.7-5.3L487.8,377.2z"
          />
          <path
            fill={colour1}
            opacity={0.5}
            d="M441.3,404c-3.1,0.7-8.7-0.1-9.3-1c-0.6-0.9,2.6-12.7,2.6-12.7L441.3,404z"
          />
          <path
            fill={colour0}
            d="M435.2,389.3c-1.1-16.8,11.3-32.4,26.3-33.6c13.5-1.1,29.4,35.9,39.3,44.1c0.1,0.5-14,2.9-35.4,16.6
			C450.4,417.6,436.3,406.1,435.2,389.3z"
          />
          <path
            fill={colour2}
            d="M438.6,388c-1-16.2,9.2-30.2,22.9-31.3c13.7-1.1,25.7,11.1,26.7,27.3c1,16.2-9.4,27.4-23.1,28.5
			C451.4,413.6,439.7,404.2,438.6,388z"
          />
          <path
            fill={colour3}
            d="M463.5,408.9c13.7-1.1,24.1-13.1,23.1-29.3c-0.2-2.6-0.6-5.1-1.3-7.5c1.7,3.6,2.7,7.6,3,11.9
			c1,16.2-9.4,28.2-23.1,29.3c-11.6,0.9-21.9-6.3-25.4-18.4C444.3,404.3,453.4,409.7,463.5,408.9z"
          />
          <path
            fill={colour4}
            d="M447.4,386.8c-0.9-9.5,5.6-18,14.4-18.9c8.8-0.9,16.7,6.1,17.5,15.6c0.9,9.5-5.6,18-14.4,18.9
			C456.1,403.3,448.3,396.3,447.4,386.8z"
          />
          <path
            fill={colour5}
            opacity={0.5}
            d="M432,402.8c-0.5-16.9,2.5-34.9,16.9-41.9c12.9-6.3,34.6-3.4,43,8.5c-15.3,1.6-38.1,22.8-51.7,34.6
			C436.8,404.4,433.4,404.2,432,402.8z"
          />
          <path
            fill={colour2}
            d="M453.1,403.6c-2.8-1.7-4.1-4.9-2.8-7.1c1.3-2.2,4.6-2.6,7.5-0.8c2.8,1.7,4.1,4.9,2.8,7.1
			C459.3,404.9,455.9,405.3,453.1,403.6z"
          />
          <path
            fill={colour2}
            d="M465.1,399.7c-1.3-0.4-2.4-1.9-2.4-3.3c0-1.5,1.1-2.4,2.5-2c1.3,0.4,2.4,1.9,2.4,3.3
			C467.5,399.2,466.4,400.1,465.1,399.7z"
          />
          <path
            fill={colour6}
            d="M489.9,367.2c-5.9-5.5-45.7-5-58.7,32.9c0,0-7.7-31.3,16.5-43C475.8,343.3,489.9,367.2,489.9,367.2z"
          />
          <path
            fill={colour6}
            d="M488.9,364c2.3,3,3.5,5.2,3.5,5.2c-6.1-5.7-37.6,14.6-60.4,33.6c0,0-0.6-1.9-1.4-5.1
			C443.9,364.1,477,360.4,488.9,364z"
          />
          <path
            fill={colour1}
            opacity={0.5}
            d="M432.6,410.4c2.7,4.9,18,16.3,32.2,14.1l-6.5,6.5C445.5,429.1,437.8,419.7,432.6,410.4z"
          />
          <path
            fill={colour6}
            d="M432,402.3l56,1.4c0,0-10.3,18.6-31.2,14.1C435.9,413.4,432,402.3,432,402.3z"
          />
        </g>
        <path
          fill={colour0}
          d="M425.3,404c1.9,0.3,6.1,0.5,11-3.7c4.9-4.2,50.5-36.5,56.2-31.1c0,0-0.6-4.2-3.5-5.2c0,0-8.8-3.1-27.8,11.7
		C442.1,390.6,437,401.1,425.3,404z"
        />
        <path
          fill={colour0}
          d="M427.9,404.1c7.3-4.1,24.8-4.5,41.2-2.1c16.4,2.4,24.5-0.3,30.8-2.5l8.3,2.2c0,0-8.4,0.8-14,2.6
		c-5.6,1.9-18.3,3.3-25,2C443,401.3,427.9,404.1,427.9,404.1z"
        />
        <path
          fill={colour0}
          d="M497.5,357.1c0,0-3.5,9-8.8,11l2.9,0.8C491.6,368.8,497.8,364.4,497.5,357.1z"
        />
        <path
          fill={colour0}
          d="M491.3,355.4c0,0-1.2,9.6-5.8,12.8l3,0C488.6,368.2,493.4,362.3,491.3,355.4z"
        />
        <path
          fill={colour0}
          d="M486.2,354.9c0,0-0.4,9.6-4.7,13.2l3-0.2C484.5,367.9,488.8,361.6,486.2,354.9z"
        />
        <path
          fill={colour0}
          d="M479.8,355.2c0,0,0.4,9.6-3.6,13.6l3-0.5C479.2,368.3,483,361.8,479.8,355.2z"
        />
        <path
          fill={colour1}
          opacity={0.5}
          d="M377.3,410.4c-2.7,4.9-18,16.3-32.2,14.1l6.5,6.5C364.3,429.1,372.1,419.7,377.3,410.4z"
        />
        <g>
          <path
            fill={colour0}
            d="M317.3,369.2c0,0-2.3,27-11.6,31.6c0,0,18.2-2.4,18.8-25.7L317.3,369.2z"
          />
          <path
            fill={colour0}
            d="M322,377.2c-2.3-2-5-6.8-4.7-7.8c0.3-1.1,12.7-5.3,12.7-5.3L322,377.2z"
          />
          <path
            fill={colour1}
            opacity={0.5}
            d="M368.6,404c3.1,0.7,8.7-0.1,9.3-1c0.6-0.9-2.6-12.7-2.6-12.7L368.6,404z"
          />
          <path
            fill={colour0}
            d="M374.6,389.3c1.1-16.8-11.3-32.4-26.3-33.6c-13.5-1.1-29.5,35.9-39.3,44.1c-0.1,0.5,14,2.9,35.5,16.6
			C359.4,417.6,373.6,406.1,374.6,389.3z"
          />
          <path
            fill={colour2}
            d="M371.2,388c1-16.2-9.2-30.2-23-31.3c-13.7-1.1-25.7,11.1-26.7,27.3c-1,16.2,9.4,27.4,23.1,28.5
			C358.4,413.6,370.2,404.2,371.2,388z"
          />
          <path
            fill={colour3}
            d="M346.3,408.9c-13.7-1.1-24.1-13.1-23.1-29.3c0.2-2.6,0.6-5.1,1.3-7.5c-1.7,3.6-2.7,7.6-3,11.9
			c-1,16.2,9.4,28.2,23.1,29.3c11.7,0.9,21.9-6.3,25.4-18.4C365.6,404.3,356.5,409.7,346.3,408.9z"
          />
          <path
            fill={colour4}
            d="M362.4,386.8c0.9-9.5-5.6-18-14.4-18.9c-8.8-0.9-16.7,6.1-17.5,15.6c-0.9,9.5,5.6,18,14.4,18.9
			C353.7,403.3,361.6,396.3,362.4,386.8z"
          />
          <path
            fill={colour5}
            opacity={0.5}
            d="M377.9,402.8c0.5-16.9-2.5-34.9-16.9-41.9c-13-6.3-34.6-3.4-43,8.5c15.3,1.6,38.1,22.8,51.7,34.6
			C373,404.4,376.5,404.2,377.9,402.8z"
          />
          <path
            fill={colour2}
            d="M338.5,389.1c0-3.3-2.1-6.1-4.6-6.1c-2.5,0-4.6,2.6-4.6,6c0,3.3,2.1,6.1,4.6,6.1
			C336.5,395.1,338.5,392.5,338.5,389.1z"
          />
          <path
            fill={colour2}
            d="M340.7,398.5c1.3-0.4,2.4-1.9,2.4-3.3c0-1.5-1.1-2.3-2.5-2c-1.3,0.4-2.4,1.9-2.4,3.3
			C338.3,398,339.4,398.9,340.7,398.5z"
          />
          <path
            fill={colour6}
            d="M319.9,367.2c5.9-5.5,45.8-5,58.8,32.9c0,0,7.7-31.3-16.5-43C334,343.3,319.9,367.2,319.9,367.2z"
          />
          <path
            fill={colour6}
            d="M320.9,364c-2.3,3-3.5,5.2-3.5,5.2c6.1-5.7,37.6,14.6,60.5,33.6c0,0,0.6-1.9,1.4-5.1
			C365.9,364.1,332.8,360.4,320.9,364z"
          />
          <path
            fill={colour6}
            d="M377.8,402.3l-56,1.4c0,0,10.3,18.6,31.2,14.1C373.9,413.4,377.8,402.3,377.8,402.3z"
          />
          <path
            fill={colour0}
            d="M384.6,404c-1.9,0.3-6.1,0.5-11-3.7c-4.9-4.2-50.6-36.5-56.2-31.1c0,0,0.6-4.2,3.5-5.2c0,0,8.8-3.1,27.8,11.7
			C367.8,390.6,372.9,401.1,384.6,404z"
          />
          <path
            fill={colour0}
            d="M382,404.1c-7.3-4.1-24.8-4.5-41.2-2.1c-16.5,2.4-24.6-0.3-30.8-2.5l-8.3,2.2c0,0,8.4,0.8,14,2.6
			c5.6,1.9,18.3,3.3,25,2C366.8,401.3,382,404.1,382,404.1z"
          />
          <path
            fill={colour0}
            d="M312.3,357.1c0,0,3.6,9,8.8,11l-2.9,0.8C318.2,368.8,312,364.4,312.3,357.1z"
          />
          <path
            fill={colour0}
            d="M318.5,355.4c0,0,1.2,9.6,5.8,12.8l-3,0C321.3,368.2,316.4,362.3,318.5,355.4z"
          />
          <path
            fill={colour0}
            d="M323.7,354.9c0,0,0.4,9.6,4.8,13.2l-3-0.2C325.4,367.9,321,361.6,323.7,354.9z"
          />
          <path
            fill={colour0}
            d="M330,355.2c0,0-0.4,9.6,3.6,13.6l-3-0.5C330.7,368.3,326.8,361.8,330,355.2z"
          />
        </g>
      </g>
    </>
  );
};

export default Eyes_14;
